import { LegalLayout } from '@/components/LegalLayout';
import { useLanguage } from '@/lib/i18n/LanguageContext';

export default function KVKKPage() {
  const { lang } = useLanguage();

  if (lang === 'tr') return (
    <LegalLayout title="KVKK Aydınlatma Metni" lastUpdated="24 Şubat 2026">
      <p>Safe Crypto olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, veri sorumlusu sıfatıyla kişisel verilerinizi aşağıda açıklanan amaçlar doğrultusunda işlemekteyiz.</p>

      <h2>1. Veri Sorumlusu</h2>
      <p><strong>Safe Crypto</strong> - safecrypto.ai<br/>İletişim: support@safecrypto.ai</p>

      <h2>2. İşlenen Kişisel Veriler</h2>
      <h3>a) Kimlik Verileri</h3>
      <p>Ad, soyad, doğum tarihi, T.C. kimlik numarası, kimlik belgesi fotokopisi</p>
      <h3>b) İletişim Verileri</h3>
      <p>E-posta adresi, telefon numarası, adres bilgileri</p>
      <h3>c) Finansal Veriler</h3>
      <p>Cüzdan adresleri, işlem geçmişi, bakiye bilgileri, yatırma/çekme kayıtları</p>
      <h3>d) Dijital Kimlik Verileri</h3>
      <p>IP adresi, çerez verileri, oturum bilgileri, cihaz bilgileri</p>
      <h3>e) Görsel Veriler</h3>
      <p>KYC sürecinde yüklenen fotoğraflar ve selfie görüntüleri</p>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Üyelik ve hesap oluşturma süreçlerinin yürütülmesi</li>
        <li>Kimlik doğrulama ve KYC süreçlerinin tamamlanması</li>
        <li>Kripto para işlemlerinin gerçekleştirilmesi</li>
        <li>5549 sayılı Suç Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun kapsamındaki yükümlülükler</li>
        <li>Müşteri memnuniyeti ve destek hizmetlerinin sunulması</li>
        <li>Platform güvenliğinin sağlanması ve dolandırıcılık önleme</li>
        <li>Yasal düzenleme ve denetim yükümlülüklerinin yerine getirilmesi</li>
        <li>İstatistiksel analiz ve raporlama</li>
      </ul>

      <h2>4. Verilerin İşlenme Hukuki Sebepleri</h2>
      <ul>
        <li>Kanunlarda açıkça öngörülmesi (KVKK m.5/2-a)</li>
        <li>Sözleşmenin kurulması veya ifası (KVKK m.5/2-c)</li>
        <li>Veri sorumlusunun hukuki yükümlülüğü (KVKK m.5/2-ç)</li>
        <li>Meşru menfaat (KVKK m.5/2-f)</li>
        <li>Açık rıza (gerekli hallerde)</li>
      </ul>

      <h2>5. Verilerin Aktarılması</h2>
      <p>Kişisel verileriniz, yukarıda belirtilen amaçlar doğrultusunda:</p>
      <ul>
        <li>Yetkili kamu kurum ve kuruluşlarına (MASAK, mahkemeler)</li>
        <li>Ödeme hizmet sağlayıcılarına</li>
        <li>KYC/AML doğrulama hizmeti sunan iş ortaklarına</li>
        <li>Bulut bilişim ve barındırma hizmet sağlayıcılarına</li>
      </ul>
      <p>aktarılabilir. Yurt dışına veri aktarımında KVKK m.9 hükümlerine uyulur.</p>

      <h2>6. Veri Sahibinin Hakları (KVKK m.11)</h2>
      <p>KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme</li>
        <li>KVKK'nın 7. maddesindeki şartlar çerçevesinde silinmesini veya yok edilmesini isteme</li>
        <li>Düzeltme, silme veya yok etme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonuç doğmasına itiraz etme</li>
        <li>Kanuna aykırı olarak işlenmesi sebebiyle zarara uğranması halinde zararın giderilmesini talep etme</li>
      </ul>

      <h2>7. Başvuru</h2>
      <p>KVKK kapsamındaki taleplerinizi <strong>support@safecrypto.ai</strong> adresine yazılı olarak iletebilirsiniz. Başvurularınız en geç 30 gün içinde ücretsiz olarak sonuçlandırılacaktır.</p>
    </LegalLayout>
  );

  return (
    <LegalLayout title="KVKK Disclosure (Turkish Data Protection)" lastUpdated="February 24, 2026">
      <p>As Safe Crypto, in accordance with the Turkish Personal Data Protection Law No. 6698 ("KVKK"), we process your personal data as data controller for the purposes described below.</p>

      <h2>1. Data Controller</h2>
      <p><strong>Safe Crypto</strong> - safecrypto.ai<br/>Contact: support@safecrypto.ai</p>

      <h2>2. Personal Data Processed</h2>
      <ul>
        <li><strong>Identity Data:</strong> Name, surname, date of birth, national ID, ID document copy</li>
        <li><strong>Contact Data:</strong> Email address, phone number, address</li>
        <li><strong>Financial Data:</strong> Wallet addresses, transaction history, balance information</li>
        <li><strong>Digital Identity Data:</strong> IP address, cookies, session data, device information</li>
        <li><strong>Visual Data:</strong> Photos and selfie images uploaded during KYC</li>
      </ul>

      <h2>3. Purposes of Processing</h2>
      <ul>
        <li>Membership and account creation processes</li>
        <li>Identity verification and KYC processes</li>
        <li>Execution of cryptocurrency transactions</li>
        <li>Obligations under Law No. 5549 on Prevention of Laundering Proceeds of Crime</li>
        <li>Customer satisfaction and support services</li>
        <li>Platform security and fraud prevention</li>
        <li>Legal regulation and audit obligations</li>
      </ul>

      <h2>4. Your Rights Under KVKK Article 11</h2>
      <ul>
        <li>Learning whether personal data is processed</li>
        <li>Requesting information about processing</li>
        <li>Learning the purpose of processing</li>
        <li>Knowing third parties to whom data is transferred</li>
        <li>Requesting correction of incomplete or incorrect data</li>
        <li>Requesting deletion or destruction of data</li>
        <li>Objecting to automated analysis results</li>
        <li>Requesting compensation for damages due to unlawful processing</li>
      </ul>

      <h2>5. Application</h2>
      <p>You can submit your KVKK requests in writing to <strong>support@safecrypto.ai</strong>. Applications will be concluded free of charge within 30 days.</p>
    </LegalLayout>
  );
}
